import Component from './Component';

export default class HeaderSearch extends Component {
  load() {
    this.initHeaderSearch();

    super.load();
  }

  initHeaderSearch() {
    const isNavBuilder = document.querySelector('.navBuilder');
    const lg = '(min-width: 992px)';
    const isDesktop = window.matchMedia(lg).matches;
    if (isNavBuilder && isDesktop) {
      // If the .navbuilder is present and the screen is desktop-sized.
      return;
    }

    // add event listeners
    const headerSearchEls = document.querySelectorAll('[data-toggle="header-search"]');
    headerSearchEls.forEach(toggleEl => {
      toggleEl.addEventListener('click', (event) => this.toggleHeaderSearch(event, toggleEl));
    });
  }

  toggleHeaderSearch(event, toggleEl) {
    // console.log('header search toggled.');
    const targetSelector = toggleEl.getAttribute('data-target');
    const action = toggleEl.getAttribute('data-action');
    const target = document.querySelector(targetSelector);

    if (target && target.dataset.status !== action) {

      event.preventDefault();
      target.dataset.status = action;
      target.classList.toggle('header-search__container--active');

      if (action === 'open') {
        const tray = document.querySelector('.header-search__tray');
        if (!tray) return;

        const duration = parseFloat(getComputedStyle(tray).transitionDuration || '0') * 1000;
        const input = target.querySelector('input[type="text"]');

        setTimeout(() => input?.focus(), duration);
      } else {
        const overlay = document.getElementById('header-search-predictive-search');
        if (overlay && !overlay.classList.contains('fade')) {
          console.log('4');
          overlay.classList.add('fade');
        }
      }
    }
  }

}
